import { Component, OnInit, Input } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";

import { APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";

@Component({
	selector: 'app-mech-comm-failures',
	templateUrl: './mech-comm-failures.component.html',
	styleUrls: ['./mech-comm-failures.component.scss']
})
export class MechCommFailuresComponent implements OnInit {

	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;

	public totalLogs = 0;
	public currentPage = 1;
	public itemsPerPage = 30;
	public pageLogs: any[] = undefined;

	constructor(private modalService: NgbModal, public api: ApiService) { }

	async ngOnInit() {
		this.refreshTable();
	}

	async updatePage() {
		const result = await this.api.GetCommFailures(this.asset.asset_id, this.itemsPerPage * (this.currentPage - 1), this.itemsPerPage);
		this.totalLogs = result.count;
		this.pageLogs = result.rows;
	}

	refreshTable() {
		this.currentPage = 1;
		this.updatePage();
	}
}
